import React, { useCallback, useEffect, useState } from 'react';

import { AbsoluteContainer, AnimationContainer } from './styled';

export interface TransitionComponentProps {
  children: React.ReactChild;
  visible?: boolean;
  transitionType?: 'fadeInUp';
}

export const TransitionComponent: React.FC<TransitionComponentProps> = ({
  transitionType,
  visible,
  children
}) => {
  const [animation, setAnimation] = useState(transitionType ? '' : undefined);
  const [renderContent, setRenderContent] = useState(visible);

  useEffect(() => {
    if (visible) {
      setRenderContent(true);

      if (transitionType) {
        setAnimation(transitionType);
      }
    } else {
      if (transitionType) {
        setAnimation('');
      } else {
        setRenderContent(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const onTransitionEnd = useCallback(() => {
    if (!visible) {
      setRenderContent(false);
    }
  }, [visible]);

  return (
    <AbsoluteContainer>
      <AnimationContainer animation={animation} onTransitionEnd={onTransitionEnd}>
        {renderContent && children}
      </AnimationContainer>
    </AbsoluteContainer>
  );
};
export default TransitionComponent;
